import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  Row,
  Typography
} from '@vivaldis/antd-ui'
import { Divider } from '../../../../../../../Divider'
import { useForm } from '../../../../provider/FormProvider'
import { CountryType } from '../../../../../../types/CountryType'

interface Props {
  countries: CountryType[]
}

export const ResidencePermit = ({ countries }: Props) => {
  const [t] = useTranslation('web_ui')
  const { values } = useForm()

  // we show RESIDENCE PERMIT when user selected non-EEA country
  const isEeaMember = useMemo(() => {
    if (!values.nationalityCountryId) {
      return true
    }

    return !!countries.find(
      country => country.id === values.nationalityCountryId
    )?.eeaMember
  }, [countries, values.nationalityCountryId])

  if (!values.nationalityCountryId) {
    return null
  }

  if (isEeaMember) {
    return null
  }

  return (
    <>
      <Divider sectionSeparator />
      <Typography.Title level={5} marginBottom={16}>
        {t(
          'edit_employee_personal_information_form.steps.enter_ssn.residence_permit_section_header'
        )}
      </Typography.Title>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="residencePermitFrontPicture"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.residence_permit_front_picture.label'
            )}
          >
            <Image
              width={250}
              height={160}
              src={String(values.residencePermitFrontPicture)}
              preview={false}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="residencePermitBackPicture"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.residence_permit_back_picture.label'
            )}
          >
            <Image
              width={250}
              height={160}
              src={String(values.residencePermitBackPicture)}
              preview={false}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="residencePermitCode"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.residence_permit_code.label'
            )}
          >
            <Input
              name="residencePermitCode"
              placeholder={t('form.required')}
              autoComplete="off"
              disabled
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="residencePermitExpiresOn"
            required
            label={t(
              'edit_employee_personal_information_form.steps.enter_ssn.residence_permit_expires_on.label'
            )}
          >
            <DatePicker
              name="residencePermitExpiresOn"
              format="dd-MM-yyyy"
              placeholder={t('form.required')}
              style={{ width: '100%' }}
              autoComplete="off"
              disabled
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
